export default {
    state: {
        floors: [],
        floor: [],
        errors: {},
        floor_id: null,
        form: {
            name: '',
            facility_id: '',
        },
        status_form: {},
        meta: {
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'created_at',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },
        table: {
            fields: [
                {key: 'id', label: 'Code', sortable: true},
                {key: 'name', label: 'Name', sortable: true},
                {key: 'facility', label: 'Facility', tdClass: 'text-muted'},
                {key: 'active', label: 'Status', sortable: true, thClass: 'text-center', tdClass: 'text-center'},
                {key: 'actions', label: 'Actions', thClass: 'text-center', tdClass: 'text-center'},
            ]
        },
        url: '/api/hms/locations/floors',
    },
    getters : {
        getFloorTableFields: state => state.table.fields,

        getFloorsMeta: state => state.meta,

        getFloorForm: state => state.form,

        getFloorErrors: state => state.errors,

        getFloorStatusForm: state => state.status_form,
    },
    mutations : {
        resetFloorsMeta: state => {
            state.meta = {
                current_page: 1,
                per_page: 10,
                total: 0,
                from: '',
                to: '',
                sort: 'desc',
                order_by: 'Choose',
                sort_by: 'created_at',
                sort_desc: true,
                search: '',
                page_sizes: [10, 25, 50, 100],
            };
        },

        setFloors: (state, payload) => {
            state.floors = payload;
        },

        setFloor: (state, payload) => {
            state.floor = payload;
        },

        setFloorsMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setFloorErrors: (state, payload) => {
            state.errors = payload;
        },

        setFloorForm: state => {
            state.form = {
                name: '',
                facility_id: '',
            };

            state.errors = {};
        },

        setFloorStatusForm: state => {
            state.status_form = {
                active: state.floor.data.attributes.status === 'Active',
                floor_id: state.floor.floor_id,
            };

            state.errors = {};
        },
    },
    actions : {
        fetchFloors: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };

            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            return new Promise((resolve, reject) => {
                axios.get(state.url+'?state', {params: parameters})
                    .then(response => {
                        commit('setFloors', response.data);

                        commit('setFloorsMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        commit('setFloorErrors', error.response.data.errors);

                        reject();
                    });
            });
        },

        fetchFloor: ({state, commit}, floor_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + floor_id)
                    .then(response => {
                        commit('setFloor', response.data);
                        commit('setFloorStatusForm', response.data);

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchEditFloor: ({state, commit}, floor_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + floor_id + '/edit')
                    .then(response => {
                        state.floor_id = response.data.id;

                        state.form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitFloor: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setFloorErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        updateFloor: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.floor_id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setFloorErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        deleteFloor: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + payload.floor_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },

        submitFloorStatus: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + payload.floor_id + '/status', payload.form)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            commit('setFloorErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            })
        },
    },
}
